import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMeasurementPickerRow = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 0,
  "& > .MuiFormControl-root": {
    flex: "1 1 auto",
    minWidth: 0,
  },
});
